import { api, GROUP_API_URL_SUB_URLS, V2 } from '@/api';
import { AxiosResponse } from 'axios';
import { Module } from 'vuex';
import { RootState } from '@/@types/member';
import { GroupPlanTypeResponseModel, GroupMigrationDates } from '@/@types/member';

interface GroupState {
  groupPlanTypeOptions: GroupPlanTypeResponseModel[];
  groupMigrationDates: GroupMigrationDates;
}

const GROUP_STATE: Module<GroupState, RootState> = {
  state: {
    groupPlanTypeOptions: [],
    groupMigrationDates: {} as GroupMigrationDates,
  },
  actions: {
    // UC-REST-047a - Get Group Plan Type Options
    getGroupPlanTypeOptions(context, options): Promise<AxiosResponse> {
      return api
        .get(
          `${GROUP_API_URL_SUB_URLS.groupComponents}/${
            options.componentId
          }/plan-types${V2}`,
          {
            headers: {
              Authorization: options.token,
              'x-group-id': options.groupId,
            },
          },
        )
        .then((planTypes) => {
          context.commit('setGroupPlanTypeOptions', planTypes.data);
          return planTypes.data;
        });
    },
    // UC-REST-052 - Validate Group
    validateGroup(context, groupId): Promise<AxiosResponse> {
      return api
        .get(`${GROUP_API_URL_SUB_URLS.groups}${V2}/${groupId}`)
        .then((data) => {
          return data.data;
        });
    },
    // UC-REST-104 - Get Group Migration Dates
    getGroupMigrationDates(context, groupId): Promise<AxiosResponse> {
      return api
        .get(`${GROUP_API_URL_SUB_URLS.groups}/${groupId}/migration-dates`)
        .then((response) => {
          context.commit('setGroupMigrationDates', response.data);
          return response.data;
        });
    },
  },
  mutations: {
    setGroupPlanTypeOptions(
      state: GroupState,
      data: GroupPlanTypeResponseModel[],
    ) {
      state.groupPlanTypeOptions = data;
    },
    setGroupMigrationDates(
      state: GroupState,
      data: GroupMigrationDates,
    ) {
      state.groupMigrationDates = data;
    },
  },
  getters: {
    groupPlanTypeOptions(state): GroupPlanTypeResponseModel[] {
      return state.groupPlanTypeOptions;
    },
    groupMigrationDates(state): GroupMigrationDates {
      return state.groupMigrationDates;
    },
  },
};

export default GROUP_STATE;
